import { call, put, takeLatest } from 'redux-saga/effects';
import { getEnabledAccounts } from 'api/EnabledAccountsAPI';
import { getErrorResponse } from 'utils/xhr';
import { addNegativeToast } from 'modules/toastContainer';
import { addToRootSaga } from 'store';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import type { EnabledAccount } from './types';

/**
 * fetchEnabledAccountsSaga
 * Saga for fetching enabled accounts
 * @return { void }
 */

export function* fetchEnabledAccountsSaga() {
  try {
    const data: EnabledAccount[] = yield call(getEnabledAccounts);
    yield put(actions.fetchEnabledAccountsResponse(data));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.fetchEnabledAccountsError(err));
    const message = `Please try again later. If the problem persists, contact your CSM.`;
    yield put(addNegativeToast(message));
  }
}

addToRootSaga([takeLatest(actionTypes.FETCH_ENABLED_ACCOUNTS_REQUEST, fetchEnabledAccountsSaga)]);
